export default class NotLoadedError extends Error {}
